import colors from './ui-colors.scss';

export default colors;
